// ModalOverlay component
import React from 'react';

function ModalOverlay({ onClose }) {
    return (
        <div className="modal-overlay" onClick={onClose}></div>
    );
}

export default ModalOverlay;